import adressFullStringGetter from '@/services/general/adressFullStringGetter';

export default function miseEnFormeAddresseTiers(dataModification) {
  let addresseTmp = dataModification.tiers.nomCommercial + ' - '
    + adressFullStringGetter(dataModification.tiers.adressePostale, false);
  if (dataModification.tiers.compteComptable) {
    addresseTmp += ' - ' + dataModification.tiers.compteComptable;
  }
  return addresseTmp;
}
